function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";
import { get } from "../../utils/storage";
var flagSetter = function(oldABFlags, flag) {
    var oldValue = oldABFlags[flag];
    var newValue = get(flag);
    if (newValue !== oldValue) {
        return _extends({}, oldABFlags, _define_property({}, flag, newValue));
    }
    return oldABFlags;
};
var withABFlags = function(flagDefaults, options) {
    if (options === void 0) options = {};
    var _options_propName = options.propName, propName = _options_propName === void 0 ? "abFlags" : _options_propName;
    return function(Component) {
        var WithABFlags = function WithABFlags(props) {
            var children = props.children;
            var _useState = _sliced_to_array(useState(function() {
                if (typeof window !== "undefined") {
                    return Object.entries(flagDefaults).reduce(function(acc, param) {
                        var _param = _sliced_to_array(param, 2), flag = _param[0], defaultValue = _param[1];
                        var currentValue = get(flag);
                        acc[flag] = currentValue === null ? defaultValue : currentValue;
                        return acc;
                    }, {});
                }
                // No session storage in SSR
                return flagDefaults;
            }), 2), abFlags = _useState[0], setABFlags = _useState[1];
            useEffect(function() {
                var _window;
                var flagNames = Object.keys(flagDefaults);
                var handlers = [];
                flagNames.forEach(function(flag) {
                    var _document;
                    var handler = function() {
                        setABFlags(function(oldABFlags) {
                            return flagSetter(oldABFlags, flag);
                        });
                    };
                    (_document = document) == null ? void 0 : _document.addEventListener("" + flag + "Set", handler);
                    handlers.push({
                        flag: flag,
                        handler: handler
                    });
                });
                var storageHandler = function(event) {
                    if (flagNames.includes(event.key)) {
                        setABFlags(function(oldABFlags) {
                            return flagSetter(oldABFlags, event.key);
                        });
                    }
                };
                (_window = window) == null ? void 0 : _window.addEventListener("storage", storageHandler);
                return function() {
                    var _window;
                    handlers.forEach(function(param) {
                        var flag = param.flag, handler = param.handler;
                        var _document;
                        (_document = document) == null ? void 0 : _document.removeEventListener("" + flag + "Set", handler);
                    });
                    (_window = window) == null ? void 0 : _window.removeEventListener("storage", storageHandler);
                };
            }, []);
            return /*#__PURE__*/ React.createElement(Component, _extends({}, props, _define_property({}, propName, abFlags)), children);
        };
        WithABFlags.displayName = "WithABFlags(" + (Component.displayName || Component.name) + ")";
        return composeDataMethods(Component)(WithABFlags);
    };
};
export default withABFlags;

//# sourceMappingURL=withABFlags.js.map